import React from 'react';
import { useSiteContacts } from '@/hooks/useSiteContacts';


export const Footer: React.FC = () => {
  const contacts = useSiteContacts();
  return (
    <footer id="contact" className="relative bg-[#EAE6D7] text-[#412018] py-24 px-6 border-t border-[#412018]/5 overflow-hidden">
      
      {/* Arabic Calligraphy Background (Subtle) */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none opacity-5">
        <div className="relative w-full h-full">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[30vw] leading-none font-serif text-[#412018] blur-sm select-none tracking-tighter" style={{ fontFamily: 'serif' }}>
              ريهام
            </span>
        </div>
      </div>

      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start relative z-10">
        <div className="mb-12 md:mb-0 max-w-sm">
          <div className="mb-8 flex justify-start -mr-10">
            <img
              src="https://cdn.shopify.com/s/files/1/0977/6965/2535/files/Container2_64bfd077-061d-46e2-9fff-6e0560b87ac0.png?v=1778077297"
              alt="RIHAM קליניקה טבעית ומערבית"
              width="306"
              height="80"
              className="h-20 w-auto object-contain object-right"
              style={{ filter: 'brightness(0) saturate(100%) invert(11%) sepia(58%) saturate(1480%) hue-rotate(353deg) brightness(94%) contrast(96%)' }}
            />
          </div>

          <p className="text-[#412018]/80 text-base leading-relaxed mb-6">
            קליניקה אקסקלוסיבית לרפואה אסתטית וטיפול טבעי.
            הרמוניה בין טכנולוגיה מתקדמת לכוחות הריפוי של האדמה.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-sm uppercase tracking-[0.1em] text-[#412018]/85">
          <div className="flex flex-col space-y-6">
            <span className="text-[#67392b] font-bold">קליניקה</span>
            <a href="#" className="hover:text-[#412018] transition-colors duration-300">אודות</a>
            <a href="#services" className="hover:text-[#412018] transition-colors duration-300">טיפולים</a>
            <a href="#appointment" className="hover:text-[#412018] transition-colors duration-300">הזמנות</a>
            <a href="/shop" className="hover:text-[#412018] transition-colors duration-300">מוצרים</a>
            <a href="/personal-pharmacy" className="hover:text-[#412018] transition-colors duration-300">רוקחות אישית</a>
          </div>
          <div className="flex flex-col space-y-6">
            <span className="text-[#67392b] font-bold">מדיה חברתית</span>
            {contacts.instagram && <a href={contacts.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[#412018] transition-colors duration-300">אינסטגרם</a>}
            {contacts.facebook && <a href={contacts.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-[#412018] transition-colors duration-300">פייסבוק</a>}
            {contacts.whatsapp && <a href={contacts.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-[#412018] transition-colors duration-300">וואטסאפ</a>}
          </div>
          <div className="flex flex-col space-y-6">
            <span className="text-[#67392b] font-bold">מידע ועזרה</span>
            <a href="/gift-card" className="hover:text-[#412018] transition-colors duration-300">שובר מתנה</a>
            <a href="/policies/privacy-policy" className="hover:text-[#412018] transition-colors duration-300">מדיניות פרטיות</a>
            <a href="/policies/terms-of-service" className="hover:text-[#412018] transition-colors duration-300">תקנון האתר</a>
            <a href="/policies/refund-policy" className="hover:text-[#412018] transition-colors duration-300">החזרות וביטולים</a>
            <a href="/policies/shipping-policy" className="hover:text-[#412018] transition-colors duration-300">משלוחים</a>
            <a href="/accessibility-statement" className="hover:text-[#412018] transition-colors duration-300">הצהרת נגישות</a>
          </div>
          <div className="flex flex-col space-y-6">
            <span className="text-[#67392b] font-bold">צור קשר</span>
            <span className="text-[#412018]">{contacts.addressHe}</span>
            <a href={`tel:${contacts.telephone}`} className="hover:text-[#412018] transition-colors duration-300">{contacts.telephoneDisplay}</a>
            <a href={`mailto:${contacts.email}`} className="hover:text-[#412018] transition-colors duration-300">{contacts.email}</a>
          </div>
        </div>

      </div>
      <div className="container mx-auto mt-24 pt-8 border-t border-[#412018]/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs uppercase tracking-widest text-[#412018]/75 relative z-10">
        <span>© 2026 קליניקת ריהאם מנסור. כל הזכויות שמורות.</span>
        <span>עוצב ופותח ע״י NEOLOOK STUDIO</span>
      </div>
    </footer>
  );
};
